/**
 * @generated SignedSource<<e157e5fc8f1c6e9fd8b78467b01f92bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalOpenedByScreenQuery$variables = {
  signalId: string;
};
export type SignalOpenedByScreenQuery$data = {
  readonly signal: {
    readonly id: string;
    readonly receiverReceipts: ReadonlyArray<{
      readonly openedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      };
      readonly user: {
        readonly email: string;
        readonly id: string;
        readonly name: string;
      } | null;
    }>;
    readonly store: {
      readonly users: ReadonlyArray<{
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
        };
      }>;
    };
  };
};
export type SignalOpenedByScreenQuery = {
  response: SignalOpenedByScreenQuery$data;
  variables: SignalOpenedByScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreUser",
  "kind": "LinkedField",
  "name": "users",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalOpenedByScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Signal",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalReceiverReceipt",
            "kind": "LinkedField",
            "name": "receiverReceipts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "openedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignalOpenedByScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Signal",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalReceiverReceipt",
            "kind": "LinkedField",
            "name": "receiverReceipts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "openedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87f00a77f7723c2d3c942cc722dd5b7e",
    "id": null,
    "metadata": {},
    "name": "SignalOpenedByScreenQuery",
    "operationKind": "query",
    "text": "query SignalOpenedByScreenQuery(\n  $signalId: ID!\n) {\n  signal(id: $signalId) {\n    id\n    receiverReceipts {\n      openedAtDate {\n        ...FormattedDate\n      }\n      user {\n        id\n        name\n        email\n      }\n    }\n    store {\n      users {\n        id\n        user {\n          id\n          name\n          email\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "9f91ac81fee8d89a843140fc74e7c438";

export default node;
